import { visit } from '../libs/Visitor'

export type verifyStatus = boolean | 'all'

export interface AssetCreatePayload {
  batch: string
  keeper: string
  keeperDepartment: string
  name: string
  number: string
  quantity: number
}

export interface AssetsSearchPayload {
  isVerified: verifyStatus
  batchs: Array<string>
  keeperDepartments: Array<string>
  keepers: Array<string>
}

export interface SelectorOptionsPayload {
  batchs: Array<string> | ['*']
  keeperDepartments?: Array<string> | ['*']
}

export interface OptionResponse {
  data: string[]
}

export interface ScanResponse {
  data: {
    quantity: number
    verifiedQuantity: number
    verified: number
    verifiedYear: string
  }
  message: string
  status: 'error' | 'success' | 'warning'
}
export interface AssetCreateResponse {
  status: string
  message: string
}

export interface ListAssetResponse {
  data: Asset[]
}

export interface Asset {
  batch: string
  number: string
  name: string
  quantity: string
  verifiedQuantity: string
  keeper: string
  keeperDepartment: string
  verified: string
  verifiedYear: string
  createdAt: string
  updatedAt: string
}

export const sic = {
  barcode: {
    file(file: File) {
      let form = new FormData()
      form.append('file', file)
      return visit<{ data: string[] }>({
        method: 'POST',
        url: 'erp/asset/barcode',
        data: form
      })
    }
  },
  asset: {
    get(payload: AssetsSearchPayload) {
      return visit<ListAssetResponse>({
        method: 'POST',
        url: 'erp/asset/assets',
        data: payload
      })
    },
    option(options: SelectorOptionsPayload) {
      return visit<OptionResponse>({
        method: 'POST',
        url: 'erp/asset/options',
        data: options
      })
    },
    upload(batchName: string, file: File) {
      let fd = new FormData()
      fd.append('file', file)
      fd.append('batch_name', batchName)
      return visit<AssetCreateResponse>({
        method: 'POST',
        url: 'erp/asset/upload',
        data: fd
      })
    },
    create(asset: AssetCreatePayload) {
      return visit<AssetCreateResponse>({
        method: 'POST',
        url: 'erp/asset/create',
        data: asset
      })
    }
  },
  operate: {
    scan(batch: string, number: string, unscan: number = 0) {
      let url = `erp/asset/scan/${number}?batch=${batch}`
      if (unscan > 0) url += `&unscan=${unscan}`
      return visit<ScanResponse>({
        method: 'PUT',
        url
      })
    }
  }
}
